// --------------------------------------------------------------
// Created On: 2023-12-11
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";

// A single asset that is being received by the current company in a transfer.
export default function IncomingTransferAssetListRow(props: Props): Component {
  return (
    <div className="p-2" data-test="incoming-transfer-row">
      <span>Asset &apos;</span>

      <b>{props.name}</b>

      <span>&apos; is being transferred from company &apos;</span>

      <b>{props.companyName}</b>

      <span>&apos;</span>
    </div>
  );
}

interface Props {
  assetId: number;
  name: string;
  companyName: string;
}
